import { Divider } from 'antd';
import { useState } from 'react';
import BussinesDataForm from './BussinesDataForm';

function VendorstartForm(props) {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 999, backdropFilter: 'blur(5px)' }}>
            <div style={{ height: '80vh', backgroundColor: 'var(--qk-card-bg)', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                <h2>Siz ro'yxatdan o'tish jarayonida men xizmat ko'rsatuvchiman deb belgiladingiz... Agar hato ko'rsatilgan bo'lsa <a href="/provider">bu yerga</a> bosing. Agar barchasi to'g'ri bo'lsa quyidagi formani to'ldiring.</h2>
                <Divider />
                <BussinesDataForm />
            </div>
        </div>
    );
}

export default VendorstartForm;